// src/components/Card.js
// Carte de contenu réutilisable partout dans l'app.

import { C, CARD_BG, INTENSITY, FONTS, RADIUS } from '../styles/theme';
import { HeartIcon } from './Icon';

export function Card({ card, isFav, onFav, compact = false }) {
  const bg = CARD_BG[card.type] || C.bgMuted;

  return (
    <div className="anim-card-in" style={{
      background: bg, borderRadius: RADIUS.xl,
      padding: compact ? '16px 16px 14px' : '22px 20px 18px',
      position: 'relative',
    }}>
      {/* Bouton favori */}
      <button onClick={() => onFav(card)} style={{
        position: 'absolute', top: 12, right: 12,
        background: 'rgba(255,255,255,0.65)',
        border: '1px solid rgba(255,255,255,0.85)',
        borderRadius: '50%', width: 32, height: 32,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: 'pointer',
      }}>
        <HeartIcon filled={isFav} size={16}/>
      </button>

      {/* Type + intensité */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: compact ? 8 : 10 }}>
        <span style={{ fontSize: 10, fontWeight: '600', letterSpacing: '0.1em', color: C.textMid, textTransform: 'uppercase' }}>
          {TYPE_LABELS[card.type] || card.type}
        </span>
        {card.intensity && <IntensityChip level={card.intensity}/>}
      </div>

      {/* Texte */}
      <p style={{
        fontFamily: FONTS.display, fontSize: compact ? 16 : 18,
        color: C.text, lineHeight: 1.45, fontStyle: 'italic',
        paddingRight: 28, margin: 0,
      }}>
        {card.text}
      </p>
    </div>
  );
}

export function IntensityChip({ level }) {
  const info = INTENSITY[level];
  if (!info) return null;
  return (
    <span style={{
      background: info.color, color: C.text,
      borderRadius: 50, padding: '3px 10px',
      fontSize: 11, fontWeight: '600',
      display: 'inline-flex', alignItems: 'center', gap: 4,
    }}>
      {info.icon} {info.label}
    </span>
  );
}

export function IntensityPicker({ value, onChange }) {
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      {[1, 2, 3].map(l => {
        const info   = INTENSITY[l];
        const active = value >= l;
        return (
          <button key={l} onClick={() => onChange(l)} style={{
            flex: 1, padding: '10px 6px', borderRadius: 14,
            border: 'none', cursor: 'pointer', transition: 'all 0.2s',
            background: active ? info.color : C.bgMuted,
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
          }}>
            <span style={{ fontSize: 18 }}>{info.icon}</span>
            <span style={{ fontSize: 11, fontWeight: '600', color: active ? C.text : C.textLight }}>
              {info.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}

const TYPE_LABELS = {
  action: 'Action', verite: 'Vérité', punition: 'Punition',
  date: 'Date', conseil: 'Conseil', ressource: 'Ressource',
};
